import axios from 'axios';
import {
  FigmaAnnotationRequest,
  FigmaAnnotationResponse,
  FigmaFileCreateRequest,
  FigmaFileResponse,
} from '../types/annotation';

const BASE_URL = process.env.REACT_APP_BACKEND_URL || '/api';

export const annotationApi = {
  getAllFiles: async (): Promise<FigmaFileResponse[]> => {
    const { data } = await axios.get(`${BASE_URL}/figma/files`);
    return data;
  },

  createOrUpdateFile: async (request: FigmaFileCreateRequest): Promise<FigmaFileResponse> => {
    const { data } = await axios.post(`${BASE_URL}/figma/files`, request);
    return data;
  },

  deleteFile: async (fileId: number): Promise<void> => {
    await axios.delete(`${BASE_URL}/figma/files/${fileId}`);
  },

  getAnnotations: async (fileKey: string, frameId?: string): Promise<FigmaAnnotationResponse[]> => {
    const { data } = await axios.get(`${BASE_URL}/figma/files/${fileKey}/annotations`, {
      params: frameId ? { frameId } : {},
    });
    return data;
  },

  createAnnotation: async (fileKey: string, request: FigmaAnnotationRequest): Promise<FigmaAnnotationResponse> => {
    const { data } = await axios.post(`${BASE_URL}/figma/files/${fileKey}/annotations`, request);
    return data;
  },

  updateAnnotation: async (id: number, request: FigmaAnnotationRequest): Promise<FigmaAnnotationResponse> => {
    const { data } = await axios.put(`${BASE_URL}/figma/annotations/${id}`, request);
    return data;
  },

  deleteAnnotation: async (id: number): Promise<void> => {
    await axios.delete(`${BASE_URL}/figma/annotations/${id}`);
  },

  exportMarkdown: async (fileKey: string, frameId?: string): Promise<string> => {
    const { data } = await axios.get(`${BASE_URL}/figma/files/${fileKey}/markdown`, {
      params: frameId ? { frameId } : {},
    });
    return data;
  },
};
